<script>
    export default {
        name: "BaseConfirmButton",
		props:{
			isDeleting: Boolean,
			disabled: Boolean
		},

		data: () => ({
			isConfirming: false,
			timer: null
		}),


		methods:{
			clickOne(){
				this.isConfirming = true
				if(this.timer){
					clearTimeout(this.timer)
				}
				this.timer = setTimeout(_ => {
					this.reset()
					this.timer = null
				}, 3000)
			},
			clickConfirm(){
				this.onConfirmed()
			},
			reset(){
				this.isConfirming = false
			},

        	onConfirmed(){
				this.reset()
				this.$emit("confirmed")
			}
		}
    }
</script>

<style>

</style>
